import { useContext } from 'react';

import AppContext from './AppContext';

export const useAppSettings = () => {
  const { state, selectors } = useContext(AppContext);

  return selectors.selectAppSettings(state);
};
